import BaseView from "../BaseView"
import * as React from "react"
import { observer } from "mobx-react"
import MobileStoreButton from "../../components/MobileStoreButton"
import { publicPath } from '../../common/Util'

const MEMBER_SERVICES_EMAIL = 'membership@letip.com'
const SUPPORT_TICKET_URL = 'https://form.asana.com/?k=TygQdlmwaWmrINDPxrqFjw&d=1207437855697532'

@observer
export default class NetworkSupportView extends BaseView {
  componentDidMount (): void {
    super.componentDidMount()
  }

  renderContentHeader () {
    return (
      <>
        <h1>Support</h1>
      </>
    )
  }

  render () {
    return <>
      <div className="card">
        <div className="card-header">
          <h6 style={{ margin: 0 }}>Need Assistance?</h6>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-8">
              <p>
                For membership questions or general assistance, contact Member Services at{' '}
                <a href={`mailto:${MEMBER_SERVICES_EMAIL}`}>{MEMBER_SERVICES_EMAIL}</a>. You may
                also <a target="_blank" href={SUPPORT_TICKET_URL}>submit a support ticket</a>, and
                the appropriate team member will follow up with you.
              </p>
              <a className="btn btn-primary" href={`mailto:${MEMBER_SERVICES_EMAIL}`}>
                <i className="fa fa-envelope"/> Email Member Services
              </a>
              &nbsp;
              &nbsp;
              <a className="btn btn-primary" target="_blank" href={SUPPORT_TICKET_URL}>
                <i className="fa fa-clipboard"/> Submit a Support Ticket
              </a>
            </div>
            <div className="col-md-4 text-center">
              <a target="_blank" href={SUPPORT_TICKET_URL}>
                <img
                  style={{ maxWidth: 200, width: '100%' }}
                  src={publicPath('img/support-ticket-qr.png')}
                  alt="Scan to open the support ticket form"
                />
              </a>
              <div className="text-muted">Scan to open the support ticket form</div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h6 style={{ margin: 0 }}>Helpful Links</h6>
        </div>
        <div className="card-body">
          <a target="_blank" href="https://letip.com/contact/">General Inquiries</a>
          <br/>
          <a target="_blank" href="https://letip.com/executive-staff/">LeTip Executive Staff</a>
          <br/>
          <a target="_blank" href="https://letip.com/corporate-staff/">LeTip Corporate Staff</a>
          <br/>
          <a target="_blank" href="https://letip.com/local-support-team/">Nationwide Area Support Team Members</a>
          <br/>
          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.letipwired.mobile">LeTip Wired&trade; Mobile App on Google Play</a>
          <br/>
          <a target="_blank" href="https://letip.com/blog/category/blogs/">Letip’s Blog</a>
          <br/>
          <a target="_blank" href="https://letipwebstore.mybigcommerce.com/">Webstore</a>

          <div className="mt-4 text-center">
            <h2>Get LeTip Wired Mobile</h2>
            <MobileStoreButton
              url="https://play.google.com/store/apps/details?id=com.letipwired.mobile&hl=en_US"
              store="android"
            />
            &nbsp;
            &nbsp;
            &nbsp;
            <MobileStoreButton
              url="https://itunes.apple.com/us/app/letip-wired/id1434770432?mt=8"
              store="ios"
            />
          </div>
        </div>
      </div>
    </>
  }
}
